/**
 * 组件名称: FixedScreen
 * 
 * 配置项说明:
 * - selector: 需要固定屏幕位置的元素选择器，默认值为 '.fixed-screen'
 * - offset: 元素固定时的顶部偏移量，默认值为 0
 * 
 * 使用方法:
 * const fixedScreen = new FixedScreen(); // 使用默认选择器和配置
 * // 如果需要自定义选择器和配置项，可以传入参数
 * // const fixedScreen = new FixedScreen('.custom-fixed-screen', {
 * //     offset: 50
 * // });
 * 
 * HTML结构:
 * <div class="fixed-screen">
 *     内容
 * </div>
 */
class FixedScreen {
    constructor(selector = '.fixed-screen', options = {}) {
        const defaultOptions = {
            offset: 0 // 元素固定时的顶部偏移量
        };

        this.selector = selector; // 选择器
        this.options = { ...defaultOptions, ...options }; // 合并配置
        this.init();
    }

    init() {
        const { offset } = this.options;

        $(this.selector).each((_, element) => {
            const $element = $(element);

            // 记录元素的初始位置
            const initialOffsetTop = $element.offset().top; // 元素距离文档顶部的距离

            $(window).on('scroll', () => {
                const scrollTop = $(window).scrollTop();

                if (scrollTop >= initialOffsetTop - offset) {
                    // 当滚动位置超过元素距离顶部的距离减去偏移量时，使用 transform 固定元素
                    const translateY = scrollTop - (initialOffsetTop - offset);
                    // $element.css({
                    //     transform: `translateY(${translateY}px)`
                    // });
                    $element.addClass('fixed');
                } else {
                    // 当滚动位置未超过元素顶部减去偏移量时，恢复为默认状态
                    // $element.css({
                    //     transform: 'none'
                    // });
                    $element.removeClass('fixed');
                }
            });
        });
    }
}

exports.FixedScreen = FixedScreen;